// fora do componente (ou no topo)
export const TAG_OPTIONS = [
  { value: "CertidaoCasamento", label: "Certidão de Casamento" },
  { value: "CertidaoNascimento", label: "Certidão de Nascimento" },
  { value: "ComprovanteResidencia", label: "Comprovante de Residência" },
  { value: "CpfFV", label: "CPF (FRENTE E VERSO)" },
  { value: "DocumentoIdentidadeFV", label: "Identidade (FRENTE E VERSO)" },
  { value: "QuitacaoServicoMilitar", label: "Quitação Serviço Militar" },
  { value: "QuitacaoEleitoral", label: "Quitação Eleitoral" },
  { value: "TituloEleitor", label: "Título de Eleitor" },
  {
    value: "CertificadoEnsinoMedioFV",
    label: "Certificado de Ensino Médio (FRENTE E VERSO)",
  },
  { value: "HistoricoEnsinoMedioFV", label: "Histórico do Ensino Médio" },
  {
    value: "ComprovanteDesempenhoEnem",
    label: "Comprovante de Desempenho do ENEM",
  },
  { value: "HistoricoFaculdadeOrigem", label: "Histórico da Faculdade" },
  {
    value: "DiplomaGraduacaoFV",
    label: "Diploma de Graduação (FRENTE E VERSO)",
  },
  {
    value: "HistoricoGraduacaoFV",
    label: "Histórico de Graduação (FRENTE E VERSO)",
  },
  { value: "ContratoAssinado", label: "Contrato Assinado" },
] as const;

export type TagValue = (typeof TAG_OPTIONS)[number]["value"]; // opcional (TS)
